import type { ReactNode } from 'react';
import { ResultsShareButton, resultsShareOf } from '../../shared/results_page/results_share.js';
import type { FlightExplorerPageCopy } from './explorer_copy.js';
import type { FlightExplorerOffer } from './search_source.js';

/** O compartilhar da busca (#5156): o link sempre; com `onDownloadPdf`, o menu
 *  com a cotação em PDF, que recebe as linhas da perna EM CENA (ordem e cortes da
 *  tela). */
export type ExplorerShare = {
  readonly onCopyLink: () => void;
  readonly onDownloadPdf?: ((rows: readonly FlightExplorerOffer[]) => void) | undefined;
};

/** O botão do título da página do explorer. */
export function shareAction(
  share: ExplorerShare | undefined,
  rows: readonly FlightExplorerOffer[],
  page: FlightExplorerPageCopy,
): ReactNode {
  const pdf = share?.onDownloadPdf;
  const view = resultsShareOf(
    page.share,
    share?.onCopyLink,
    pdf
      ? {
          copy: {
            copyLinkLabel: page.copyLink,
            downloadPdfLabel: page.downloadPdf,
          },
          onDownloadPdf: pdf,
        }
      : undefined,
    rows,
  );
  return view ? <ResultsShareButton share={view} /> : undefined;
}
